// extracted by mini-css-extract-plugin
export default {"addressSection":"NT-z","disabled":"OT-z","sectionButtons":"PT-z","logo":"QT-z"};